import { t } from "i18next";
import { setDataIsUpdatedFranchise, setDataIsUpdatedShops } from "../store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { useCallback, useState } from "react";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";

export function countVatRates(
    dataFranchise: any[],
    dataShops: any[],
    franchise: boolean,
    shopID: any
) {
    let archived = 0;
    let notArchived = 0;

    // Compte pour les franchises
    if (dataFranchise && dataFranchise.length > 0) {
        dataFranchise.forEach((el: any) => {
            if (el.archived) archived++;
            else notArchived++;
        });
    }

    const listNumberOrigin = {
        nbrArchived: archived,
        nbrNotArchived: notArchived,
    };

    // Compte pour les boutiques
    let shopArchived = 0;
    let shopNotArchived = 0;

    if (dataShops && dataShops.length > 0) {
        if (!franchise) {
            archived = 0;
            notArchived = 0;

            dataShops.forEach((el: any) => {
                if (el.shopId === shopID && el.subRows?.length > 0) {
                    el.subRows.forEach((elx: any) => {
                        if (elx.archived) archived++;
                        else notArchived++;
                    });
                }
            });

            // Mise à jour pour boutique spécifique
            return {
                listNumberOrigin: {
                    nbrArchived: archived,
                    nbrNotArchived: notArchived,
                },
                listNumberBoutique: { nbrArchived: 0, nbrNotArchived: 0 },
            };
        } else {
            dataShops.forEach((el: any) => {
                if (el.subRows?.length > 0) {
                    el.subRows.forEach((elx: any) => {
                        if (elx.archived) shopArchived++;
                        else shopNotArchived++;
                    });
                }
            });
        }
    }

    const listNumberBoutique = {
        nbrArchived: shopArchived,
        nbrNotArchived: shopNotArchived,
    };

    return { listNumberOrigin, listNumberBoutique };
}

export function makeId(length: any) {
    var result = "";
    var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
}

export const normalizeValue = (val: string) => val?.replace(",", ".") || "";

export const searchVatRateUppercase = (
    array: any[],
    code: string,
    value: string
) => {
    if (!array?.length) return -1;
    return array.findIndex(
        (el) =>
            el.code?.toUpperCase() === code.toUpperCase() &&
            el.value?.toUpperCase() === value.toUpperCase()
    );
};

export const getPaysDiff = (arr1: any[], arr2: any[]) =>
    arr1.filter((el) => arr2.indexOf(el) === -1);

export type vatRateFormType = {
    dataVatRate: any;
    setDatavatRate: Function;
    dataM: any;

    editedData: any;
    setEditedData: Function;
    selectedRows: any;
    isAddVatRateClicked: boolean;
    setIsAddVatRateClicked: Function;
    dataTable: any;
    pays: any;
    dataState: any;
    isAddNewVatRateButtonClicked: boolean;
    isConsult: boolean;
    setIsConsult: Function;
};

export function cleanForm({
    setCanValidate,
    setVateRate,
    setCodeVateRate,
    setTagVateRateItem,
    setPaysVateRateItem,
    setPaysVateRateData,
    setIsEdited,
    clearData,
    clearMultiCustomSelectionData,
    setInputCodeVateRate,
    setInputVateRate,
    setInputPaysVateRate,
    setDataPaysVateRateDiff,
}: any) {
    setCanValidate(true);
    setVateRate("");
    setCodeVateRate("");
    setTagVateRateItem([]);
    setPaysVateRateItem([]);
    setPaysVateRateData([]);
    setIsEdited(false);
    clearData();
    clearMultiCustomSelectionData();
    setInputCodeVateRate(false);
    setInputVateRate(false);
    setInputPaysVateRate(false);
    setDataPaysVateRateDiff([]);
}

export async function associate(
    obj: any,
    setIsSendingTag: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/vatRate/associate`;
        await fetchGlobal(apiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" }, // ← AJOUTER CECI !
            body: JSON.stringify(obj),
        });

        setDataIsUpdatedShops!(true);
        setDataIsUpdatedFranchise!(true);
        setIsSendingTag(true);
    } catch (error) {
        console.error(error);
    }
}

export function searchPosInArrayObjectVatRateUppercase(array: any, req: any) {
    let pos = -1;
    if (array.length > 0) {
        array.forEach((el: any, i: number) => {
            if (
                el.code.toUpperCase() === req.code.toUpperCase() &&
                el.value.toUpperCase() === req.value.toUpperCase()
            ) {
                pos = i;
            }
        });
    }

    return pos;
}

export function paysDiff(arr1: any, arr2: any) {
    let res: any = [];
    arr1.forEach((element: any) => {
        if (arr2.indexOf(element) === -1) {
            res.push(element);
        }
    });
    return res;
}

export function fetchShopsPays(id: string, dataShops: any) {
    let res: any = [];
    dataShops.forEach((el: any) => {
        // eslint-disable-next-line array-callback-return
        if (
            // eslint-disable-next-line array-callback-return
            el.subRows.filter(function (x: any) {
                if (x.Id === id) {
                    return x;
                }
            }).length > 0 &&
            res.indexOf(el[t("Country")]) === -1
        ) {
            res.push(el[t("Country")]);
        }
    });
    return res;
}

export async function refreshTags(
    userID: any,
    franchiseID: any,
    setTagsVateRate: any,
    tagVateRateItem: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/tag?userId=${userID}&shopId=0&franchiseId=${franchiseID}&deviceType=tag`;
    clearMultiCustomSelectionData();
    try {
        const data: any = await fetchGlobal(apiUrl, {
            headers: {
                "Content-Type": "application/json",
            },

            method: "GET",
        });
        let listOfTag: any = [];
        data.data.forEach((element: any) => {
            listOfTag.push(element.Designation);
        });
        setTagsVateRate(listOfTag);
        if (Object.keys(tagVateRateItem).length === 0) {
        }

        if (data.error) {
            throw Error("Error!");
        }
    } catch (e: any) {}
}
export type FormDataType = {
    code: string;
    value: string;
    tags: string[];
    paysData: string[];
};

export type ValidationErrors = {
    code: boolean;
    codeExists: boolean;
    value: boolean;
    valueInvalid: boolean;
    pays: boolean;
};

export const useFormState = (initialData: FormDataType) => {
    const [form, setForm] = useState<FormDataType>(initialData);

    const updateField = useCallback(
        <K extends keyof FormDataType>(field: K, value: FormDataType[K]) => {
            setForm((prev) => ({ ...prev, [field]: value }));
        },
        []
    );

    const resetForm = useCallback(() => {
        setForm(initialData);
        clearData();
        clearMultiCustomSelectionData();
    }, [initialData]);

    return { form, updateField, resetForm, setForm };
};

// Custom hook for validation
export const useValidation = () => {
    const [errors, setErrors] = useState<ValidationErrors>({
        code: false,
        codeExists: false,
        value: false,
        valueInvalid: false,
        pays: false,
    });

    const setError = useCallback(
        <K extends keyof ValidationErrors>(field: K, value: boolean) => {
            setErrors((prev) => ({ ...prev, [field]: value }));
        },
        []
    );

    const resetErrors = useCallback(() => {
        setErrors({
            code: false,
            codeExists: false,
            value: false,
            valueInvalid: false,
            pays: false,
        });
    }, []);

    const validate = useCallback(
        (form: FormDataType, codeExists: boolean): boolean => {
            const newErrors: ValidationErrors = {
                code: !form.code.trim(),
                codeExists,
                value: !form.value.trim(),
                valueInvalid:
                    form.value.trim() !== "" &&
                    (Number(form.value) < 0 || Number(form.value) > 100),
                pays: form.paysData.length === 0,
            };
            setErrors(newErrors);
            return !Object.values(newErrors).some(Boolean);
        },
        []
    );

    return { errors, setError, resetErrors, validate };
};
